/*
  Quick JS by Jason @ freakdesign.
  Questions? Ping me on twitter: @freakdesign
  Relates to blog post:
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
  Example:
  https://jasons-experiments.myshopify.com/products/alex-twill-pant-mariner
*/
(function(){
	"use strict";
	/* In case you want to output a bunch of things to the debug console */
	var debug = false;
	var cartCookie;
  var shippingCalcExist = document.querySelector('.shipping-calc-wrapper');
	if(shippingCalcExist) return;
	/* The ID of the element that you want to add the shipping fields into */
  var productSection = document.querySelector('.shopping-calculator');
	if(!productSection){ log('Could not find the element'); return }
	/* the main product select element */
	var productSelect = document.querySelector('#product-id');
	if(!productSelect){ log('Could not find the main select element'); return }
	/* create a message box */
	var shippingMessage = document.createElement('p');
	var shippingCountry = document.createElement('select');
	var shippingProvince = document.createElement('select');
	var shippingZip = document.createElement('input');
	/* We are just adding some dummy fields for example only. There's better ways to handle this */
	var initFields = function(){
		/* create the country picker */
		var countries = ['Brazil'];
		for (var i = 0; i < countries.length; i++) {
			shippingCountry.add(new Option(countries[i], countries[i], i===0));
		};
		shippingCountry.name = 'shipping_address[country]';
		/* create the province state picker */
		var provinces = ['Santa Catarina'];
		for (var i = 0; i < provinces.length; i++) {
			shippingProvince.add(new Option(provinces[i], provinces[i], i===0));
		};
		shippingProvince.name = 'shipping_address[province]';
		/* create the zip / postcode field */
		shippingZip.type = 'text';
		shippingZip.name = 'shipping_address[zip]';
    shippingZip.value = '';
    shippingZip.placeholder = 'Insira seu CEP';
    shippingZip.addEventListener('input', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const zipValue = this.value.replace(/\D/g, '');
      const calcButton = document.querySelector('.shippingCalcButton');
      
      if (zipValue.length >= 8) {
        calcButton.disabled = false;
        calcButton.classList.remove('disabled');
        calcButton.classList.add('enabled');
      } else {
        calcButton.disabled = true;
        calcButton.classList.add('disabled');
        calcButton.classList.remove('enabled');
      }
    });
    
    shippingZip.addEventListener('keypress', function(e) {
      const charCode = e.which ? e.which : e.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        e.preventDefault();
      }
    });
		var dontKnowZipLink = document.createElement('a');
		dontKnowZipLink.href = 'https://buscacepinter.correios.com.br/app/endereco/index.php';
		dontKnowZipLink.target = '_blank';
		dontKnowZipLink.rel = 'noopener';
		dontKnowZipLink.crossOrigin = '';
		dontKnowZipLink.innerText = 'não sei meu cep';
		dontKnowZipLink.className = 'dont-know-zip-link'; //
		/* create a wrapper for the fields */
		var shippingCalcWrapper = document.createElement('form');
		shippingCalcWrapper.className = 'shipping-calc-wrapper';
		var shippingSvg = '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M23.1956 5.96875L21.8831 2.6875C21.7718 2.40988 21.5796 2.17209 21.3316 2.00494C21.0835 1.83778 20.791 1.74897 20.4919 1.75H17.25V1C17.25 0.801088 17.171 0.610322 17.0303 0.46967C16.8897 0.329018 16.6989 0.25 16.5 0.25H2.25C1.85218 0.25 1.47064 0.408035 1.18934 0.68934C0.908035 0.970644 0.75 1.35218 0.75 1.75V12.25C0.75 12.6478 0.908035 13.0294 1.18934 13.3107C1.47064 13.592 1.85218 13.75 2.25 13.75H3.84375C4.00898 14.3953 4.38428 14.9673 4.91048 15.3757C5.43669 15.7842 6.08387 16.0059 6.75 16.0059C7.41613 16.0059 8.06331 15.7842 8.58952 15.3757C9.11573 14.9673 9.49102 14.3953 9.65625 13.75H14.3438C14.509 14.3953 14.8843 14.9673 15.4105 15.3757C15.9367 15.7842 16.5839 16.0059 17.25 16.0059C17.9161 16.0059 18.5633 15.7842 19.0895 15.3757C19.6157 14.9673 19.991 14.3953 20.1563 13.75H21.75C22.1478 13.75 22.5294 13.592 22.8107 13.3107C23.092 13.0294 23.25 12.6478 23.25 12.25V6.25C23.2503 6.15361 23.2318 6.0581 23.1956 5.96875ZM17.25 3.25H20.4919L21.3919 5.5H17.25V3.25ZM2.25 1.75H15.75V7.75H2.25V1.75ZM6.75 14.5C6.45333 14.5 6.16332 14.412 5.91665 14.2472C5.66997 14.0824 5.47771 13.8481 5.36418 13.574C5.25065 13.2999 5.22094 12.9983 5.27882 12.7074C5.3367 12.4164 5.47956 12.1491 5.68934 11.9393C5.89912 11.7296 6.16639 11.5867 6.45737 11.5288C6.74834 11.4709 7.04994 11.5006 7.32403 11.6142C7.59811 11.7277 7.83238 11.92 7.9972 12.1666C8.16203 12.4133 8.25 12.7033 8.25 13C8.25 13.3978 8.09197 13.7794 7.81066 14.0607C7.52936 14.342 7.14783 14.5 6.75 14.5ZM14.3438 12.25H9.65625C9.49102 11.6047 9.11573 11.0327 8.58952 10.6243C8.06331 10.2158 7.41613 9.99412 6.75 9.99412C6.08387 9.99412 5.43669 10.2158 4.91048 10.6243C4.38428 11.0327 4.00898 11.6047 3.84375 12.25H2.25V9.25H15.75V10.4041C15.4051 10.6034 15.1032 10.8692 14.8619 11.1861C14.6205 11.5029 14.4444 11.8646 14.3438 12.25ZM17.25 14.5C16.9533 14.5 16.6633 14.412 16.4166 14.2472C16.17 14.0824 15.9777 13.8481 15.8642 13.574C15.7507 13.2999 15.7209 12.9983 15.7788 12.7074C15.8367 12.4164 15.9796 12.1491 16.1893 11.9393C16.3991 11.7296 16.6664 11.5867 16.9574 11.5288C17.2483 11.4709 17.5499 11.5006 17.824 11.6142C18.0981 11.7277 18.3324 11.92 18.4972 12.1666C18.662 12.4133 18.75 12.7033 18.75 13C18.75 13.3978 18.592 13.7794 18.3107 14.0607C18.0294 14.342 17.6478 14.5 17.25 14.5ZM21.75 12.25H20.1563C19.989 11.6063 19.613 11.0362 19.0871 10.629C18.5612 10.2218 17.9151 10.0006 17.25 10V7H21.75V12.25Z" fill="currentColor"/></svg>';
		var getShippingCalcLabel = function() {
			return window.matchMedia('(max-width: 749px)').matches
				? shippingSvg + ' calcular o frete'
				: shippingSvg + ' calcule o frete e prazo de entrega:';
		};
		/* create a title */
		var shippingCalcTitle = document.createElement('p');
		shippingCalcTitle.className = 'shipping-calc-title';
		shippingCalcTitle.innerHTML = getShippingCalcLabel();
		/* create a get rates button */
		var shippingCalcButton = document.createElement('button');
		shippingCalcButton.innerText = 'Calcular';
		shippingCalcButton.className = 'button shippingCalcButton';
		shippingCalcWrapper.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
			if(!productSelect.value.length){ return false }
			
			const zipValue = shippingZip.value.replace(/\D/g, '');
			if (zipValue.length < 8) {
				shippingMessage.innerHTML = '<p style="color: #df3630; font-size: 14px;">Por favor, digite um CEP válido com 8 dígitos.</p>';
				return false;
			}
			
			if(shippingZip.value != ''){
				shippingCalcButton.innerText = 'Calculando...';
				shippingCalcButton.className += ' disabled';
			}
			cartCookie = getCookie('cart');
			var tempCookieValue = tempCookieValue || "temp-cart-cookie___" + Date.now();
			var fakeCookieValue = fakeCookieValue || "fake-cart-cookie___" + Date.now();
			/* if not found, make a new temp cookie */
			if(!cartCookie){ 
				log('no cookie found');
				updateCartCookie(tempCookieValue);
				cartCookie = getCookie('cart');
			}else{
				log('cookie found');
			}
			/* if found but has a weird length, bail */
			if(cartCookie.length < 32){ log('cart ID not valid');return }
			/* Change the cookie value to a new 32 character value */
			updateCartCookie(fakeCookieValue);
			log(getCookie('cart'));
			getRates(parseInt(productSelect.value));
			return false;
		});
		/* create some labels for the fields */
		var labelNames = ['CEP'];
		var labels = [];
		for (var i = 0; i < labelNames.length; i++) {
			var label = document.createElement('label');
			label.innerText = labelNames[i];
			labels.push(label);
		};
		shippingCalcWrapper.appendChild(shippingCalcTitle);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingCountry);
		// shippingCalcWrapper.appendChild(labels[0]);
		// shippingCalcWrapper.appendChild(shippingProvince);
		// shippingCalcWrapper.appendChild(labels[1]);
		shippingCalcWrapper.appendChild(shippingZip);
		shippingCalcWrapper.appendChild(shippingCalcButton);
		shippingCalcWrapper.appendChild(dontKnowZipLink);
		shippingCalcWrapper.appendChild(shippingMessage);
		/* add to the page */
		productSection.appendChild(shippingCalcWrapper);
	};
	/* A console logging function */
	function log (a){
		if(!debug){ return }
		console.log(a);
	};
	/* get cookie by name */
	var getCookie = function(name) {
		var value = "; " + document.cookie;
		var parts = value.split('; '+name+'=');
		if (parts.length == 2) return parts.pop().split(";").shift();
	};
	/* update the cart cookie value */
	var updateCartCookie = function(a) {
		log('changing cart cookie value to: '+a);
		var date = new Date();
		date.setTime(date.getTime()+(14*86400000));
		var expires = '; expires='+date.toGMTString();
		document.cookie = 'cart='+a+expires+'; path=/';
	};
	/* reset the cart cookie value */
	var resetCartCookie = function(){
		updateCartCookie(cartCookie);
		log(getCookie('cart'));
	};
	/* get the rates */
	var getRates = function(variantId){
		/* add whatever sanity checks you need in addition to the one below */
		if(typeof variantId === 'undefined'){ return }
		/* the main quantity element */
		var productQuantity = document.querySelector('.quantity__input');
		var quantity = productQuantity ? parseInt(productQuantity.value):1;
		var addData = {
			'id':variantId,
			'quantity':quantity
		};
		fetch('/cart/add.js', {
			body: JSON.stringify(addData),
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/json',
				'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
			},
			method: 'POST'
		}).then(function(response) {
			return response.json();
		}).then(function(json) {
      /* we have JSON */

      fetch('/cart/shipping_rates.json?' + new URLSearchParams({
        'shipping_address[country]':shippingCountry.value,
        'shipping_address[province]':shippingProvince.value,
        'shipping_address[zip]':shippingZip.value
      })).then(function(response) {
        return response.json();
      }).then(function(result) {
        if(result.shipping_rates && result.shipping_rates.length){
          let messageHtml = '';
          
          for (let i = 0; i < result.shipping_rates.length; i++) {
            const element = result.shipping_rates[i];
            let deliveryDays = '';
            
            if (element.delivery_days && element.delivery_days.length > 0 && element.delivery_days[0] !== undefined) {
              if (element.delivery_days[0] == 1) {
                deliveryDays = '<span>1 dia útil</span>';
              } else {
                deliveryDays = `<span>${element.delivery_days[0]} dias úteis</span>`;
              }
            }

            let precoFormatadoBase = `R$ ${element.price.replace('.', ',')}`;
            let precoFinal = precoFormatadoBase;

            if (element.price === "0.00") {
              precoFinal = "<strong>GRÁTIS</strong>";
            }

            messageHtml += `
            <li> 
              ${element.name} por ${precoFinal}
              ${deliveryDays ? '<br>' + deliveryDays : ''}
            </li>
            `;
          }
          
          shippingMessage.innerHTML = `<ul>${messageHtml}</ul>`;
          document.querySelector('.shippingCalcButton').innerText = 'Calcular';
          document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
        }
        resetCartCookie()
      }).catch(function() {
        resetCartCookie();
        shippingMessage.innerHTML = '';
        document.querySelector('.shippingCalcButton').innerText = 'Calcular';
        document.querySelector('.shippingCalcButton').className = 'button shippingCalcButton';
      })
    }).catch(function(err) {
      /* uh oh, we have error. */
      console.error(err);
      resetCartCookie()
    });
  };
  initFields();
})()